import React, { FC } from 'react';
import styled from 'styled-components';
import { ThemeProps } from '../../styles/theme';

// SVG for the congratulatory illustration
const CompletionSvg: FC = () => (
  <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Circle background */}
    <circle cx="100" cy="100" r="90" fill="currentColor" opacity="0.1" />
    
    {/* Trophy */}
    <path d="M70 60H130V75C130 92.6731 115.673 107 98 107H102C84.3269 107 70 92.6731 70 75V60Z" 
          fill="currentColor" opacity="0.7" />
    <rect x="90" y="107" width="20" height="25" fill="currentColor" opacity="0.8" />
    <rect x="75" y="132" width="50" height="8" rx="2" fill="currentColor" opacity="0.9" />
    
    {/* Trophy handles */}
    <path d="M70 70C60 70 55 75 55 85" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
    <path d="M130 70C140 70 145 75 145 85" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
    
    {/* Stars */}
    <path d="M50 50L55 55M50 55L55 50" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M150 50L155 55M150 55L155 50" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M50 150L55 155M50 155L55 150" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M150 150L155 155M150 155L155 150" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    
    {/* Checkmark */}
    <path d="M85 90L95 100L115 80" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const Container = styled.div<ThemeProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 20px;
  text-align: center;
  background-color: ${({ theme }) => theme.reviewCardBackground};
  color: ${({ theme }) => theme.primaryText};
`;

const IllustrationContainer = styled.div<ThemeProps>`
  color: ${({ theme }) => theme.primaryColor};
  margin-bottom: 30px;
`;

const Title = styled.h1<ThemeProps>`
  font-size: 24px;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.primaryText};
`;

const Message = styled.p<ThemeProps>`
  font-size: 16px;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.secondaryText};
  max-width: 500px;
  line-height: 1.5;
`;

export const CompletedScreen: FC = () => {
  return (
    <Container data-testid="review-completed">
      <IllustrationContainer>
        <CompletionSvg />
      </IllustrationContainer>
      <Title>Congratulations!</Title>
      <Message>
        You've completed all your reviews for today. 
        Take a well-deserved break and come back tomorrow for new cards.
      </Message>
    </Container>
  );
};

CompletedScreen.displayName = 'CompletedScreen';
